import {errorMessageHandler} from 'helpers/Alert';
import {localDateSender} from 'helpers/UnitsFormatHandler';
import {useGetCageAvailableFishGroupQuality, useGetFishGroup} from 'hooks/swr';
import {type AppAxiosError} from 'interfaces';
import {type OptionsObject, type SnackbarKey, type SnackbarMessage} from 'notistack';
import useParseURL from './useParseURL';

export const useGetAvailableFishGroup = ({
  cageId,
  date,
  fetch,
}: {
  cageId: string | undefined;
  date: Date | undefined;
  fetch: boolean;
}) => {
  const {planId} = useParseURL();
  const shouldFetch = !!cageId && !!date && fetch;

  const availableFishGroupResourceId = shouldFetch ? [cageId, localDateSender(date)] : undefined;
  const {data: availableFishGroup} = useGetCageAvailableFishGroupQuality({
    resourceId: availableFishGroupResourceId,
    errorHandler,
  });

  const availableFishGroupId = availableFishGroup?.[0]?.availableFishGroupId;
  const fishGroupResourceId =
    shouldFetch && planId && availableFishGroupId ? [planId, availableFishGroupId] : undefined;
  const {data: fishGroup} = useGetFishGroup({
    resourceId: fishGroupResourceId,
    errorHandler,
  });

  return fishGroup;
};

const errorHandler = (
  error: AppAxiosError,
  enqueueSnackbar: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey,
) => {
  if (error.response?.status === 404) {
    return;
  }
  const errorMessage = errorMessageHandler(error);
  enqueueSnackbar(errorMessage, {
    variant: 'error',
  });
};
